export default "__VITE_ASSET__BJLTa9Sz__"